module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-67.be358be7.svg";